import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { GrupoService } from '../../../_services/grupo.service';
import { Grupo } from '../../../_models/grupo';
import { GrupoZona } from '../../../_models/grupo-zona';
import { GrupoZonaService } from '../../../_services/grupo-zona.service';

@Component( {
  selector: 'app-estructura-fisica-detalle',
  templateUrl: 'asignar-grupos-detalle.component.html'
} )

export class AsignarGruposDetalleComponent implements OnInit {
  carInformacionInicial = true;
  columnas: any[];
  grupo: Grupo;
  gruposZonas: GrupoZona [] = [];

  constructor( private route: ActivatedRoute,
               private grupoZonaServicio: GrupoZonaService,
               private grupoServicio: GrupoService,
               private navServicio: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'GRUPO.LBL_CODIGO' ), sort: false },
      { field: 'nombreZona', header: this.navServicio.buscarMensaje( 'GRUPO.LBL_ZONA' ), sort: true },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      this.grupoServicio.obtenerPorId( params[ 'id' ] ).subscribe(
        grup => {
          this.grupo = grup;
          this.grupoZonaServicio.listadoPorIdGrupo( this.grupo.idGrupo ).subscribe(
            grupZonas => {
              this.gruposZonas = grupZonas;
              this.carInformacionInicial = false;
            });
        });
    } );
  }

  regresar() {
    this.location.back();
  }
}
